import React from 'react';

import style from './ordersStyle.module.css';

import fdLogo from '../../../assets/fd_text_logo.png';

interface commonOrdersIncognitoHeaderProps {
  number: string;
  forwarder: { org: string, orgAddress: string }
  type: string;
};

const commonOrdersIncognitoHeader = (props: commonOrdersIncognitoHeaderProps) => {

  const title: string = props.type === 'po' ? 'Pick Up Order:' : 'Drop Off Order:';

  return (
      
      <div className= { `${ style.flex } ${ style.headerIncognito }`}>

        <div className={ style.headerWrapperIncognito }>
          <img alt="frontline dynamics logo" src={ fdLogo } className={ style.logoImg } />
        </div>
        
        <div className={ style.titleWrapperIncognito }>
          <div className={ style.orderTitleIncognito }>{ title }</div>
          <div className={ style.orderNumberIncognito }>{ props.number }</div>
        </div>

        <div className={ style.headerCompanyInfoIncognito } >
          <div className={ style.headerCompanyInfoIncognito1 }>{ props.forwarder.org }</div>
          <div className={ style.headerCompanyInfoIncognito2 }>{ props.forwarder.orgAddress }</div>
        </div>
        
      </div>
     
  );
}

export default commonOrdersIncognitoHeader;